<template>
  <div class="modal fade in commom-modal contactus" id="contactus" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog modal-lg contactus-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class='popup-header-dev row no-gutters'>
          <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
            <div class='wrap-txt'>
              <h1 class='f black header-title'>Contact Us</h1>
              <p class='f black header-para'>
              Tiberias is a work in progress—and we’re eager for your feedback, about its functionality, documentation, errors, or any questions or concerns you may have.
              </p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
            <button type="button" data-dismiss="modal" class="common-close-btn"><i class="close-btn-icon fa fa-times"></i>Close</button>
            <!-- <button type="button" data-dismiss="modal" class="mobile-close-button"><i class="close-btn-icon fa fa-times"></i></button> -->
          </div>
        </div>
        <form id="contact-form" class='form contactus-form' action="https://formspree.io/tiberias@dicta.org.il" target="_blank" method="POST">
          <div class='field-holder form-group error'>
            <div class='row'>
              <div class='col-xs-6'>
                <label>Name</label>
              </div>
              <div class='col-xs-6 text-right'>
                <label style="display: none" class='error-txt'>Required field</label>
              </div>
            </div>
            <input class='form-control contact-form-control' required name="name" type='text'/>
          </div>
          <div class='field-holder form-group'>
            <div class='row'>
              <div class='col-xs-6'>
                <label>Email</label>
              </div>
              <div class='col-xs-6 text-right'>
                <label style="display: none" class='error-txt'>Required field</label>
              </div>
            </div>
            <input class='form-control contact-form-control' required name="_replyto" type='email'/>
          </div>
          <div class='field-holder form-group'>
            <div class='row'>
              <div class='col-xs-6'>
                <label>Description</label>
              </div>
              <div class='col-xs-6 text-right'>
                <label style="display: none" class='error-txt'>Required field</label>
              </div>
            </div>
            <textarea name="message" required class='form-control contact-form-control'></textarea>
          </div>
          <div class='field-holder bottom-btn-div'>
            <button type="submit" class="button hoverable bg-blue btn-custom"><p class="mb-0">Send</p></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contactUs',
  data () {
    return {
    }
  }
}
</script>
<style scoped src="../assets/Styles/common-modal.css"></style>
<style scoped src="../assets/Styles/common-contact-us.css"></style>
<style scoped>
#contactus {
  z-index: 9999;
}
.contactus-form .field-holder {
  display: block !important;
}
.contactus-form button p {
  font-size: 14px;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue